import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getLocaleLabel = (locale: string | Nullish): string | null => {
  if (!locale) {
    return null;
  }

  const [language] = locale.split('-');

  return `${i18n.t(`entity.tenant.labels.language-${language}`)} (${locale})`;
};
